import { RootStoreModel } from "@redux/reducers";
import {
  Button,
  Col,
  Dropdown,
  FloatButton,
  Form,
  Input,
  Layout,
  Menu,
  notification,
  Row,
  Select,
  Space,
} from 'antd';
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from 'react-router';
import { MSALObjLogin } from "../auth/authInstance";
import "./pages.scss";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

function ContactPage() {
  const user = useSelector((state: RootStoreModel) => state.userState);
  const history = useHistory()
  const [dataForm] = Form.useForm()
  const { t } = useTranslation();

  var paddingWidth = (document.body.clientWidth - 1200) > 0 ? (document.body.clientWidth - 1200) / 2 : 8
  useEffect(() => {
    console.log("屏幕宽和高", document.body.clientWidth, document.body.clientHeight)
  }, [])
  const onOk = () => {
    dataForm.validateFields().then((res)=>{
      notification.success({ message: "提交成功" });
    })
  };

  return (
    (<Layout style={{ minWidth: 1200 }} >
      <FloatButton.BackTop />
      <a id="index"></a>
      <div className="bgBox indexPadding" style={{ width: "100%", height: 74, paddingRight: paddingWidth, paddingLeft: paddingWidth,marginTop:0
      }}>
        <Row style={{padding:16}}>
          <Col span={17}>
            <Space
              align="baseline"
              style={{
                alignItems: "center",
                verticalAlign: "baseline"
              }}
            >
              <div  className="indexTopCom imgCenter" style={{ color: "#000", fontSize: 26 }}>
              {process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
                <img className="imgCenter" style={{width:70,marginLeft:88}} src="/images/title.jpg"></img>
              }
              {!process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
                <img className="imgCenter" style={{height:35,marginLeft:88}} src="/images/title.jpg"></img>
              }
              {process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
                <span style={{marginLeft:16,fontWeight:600}}>{t("未瓴")}</span>
              }
              {!process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
                <span style={{marginLeft:16,fontWeight:600}}>{t("未瓴")}</span>
              }
              </div>
              <div className="indexTopNav" ><a href="/" style={{ color: "#666" }}>{t("首页")}</a></div>
              <div className="indexTopNav" ><a href="/#product" style={{ color: "#666" }}>{t("产品")}</a></div>
              <div className="indexTopNav" ><a href="/#about" style={{ color: "#666" }}>{t("关于我们")}</a></div>
              <div className="indexTopNav" ><a href="#" style={{ color: "#666" }}>{t("联系我们")}</a></div>
              </Space>
          </Col>
          <Col span={6} style={{ textAlign: "right", margin: "auto",paddingLeft:38 }}>
            <div className="indexTopNav" style={{display: "flex",width:"100%", gap: "32px"}}>
              {user.isLogin ? (
                <a  href="/home/index"  className="indexButton">{t("控制台")}</a>
              ) : (

                <a  href="/login"   className="indexButton" >{t("Sign in")}</a>
              )}
             {!user.isLogin && (<a  href="/register"  style={{backgroundColor:"#3B89FE",color:"#fff",paddingLeft:4,paddingRight:4}} className="indexButton" >{t("注册")}</a>)}
              <Dropdown  placement="bottomCenter" dropdownRender={() => (
                <Menu onClick={(e) => { i18n.changeLanguage(e.key);console.log("i18n",i18n) }} selectable={true} defaultSelectedKeys={[i18n.language]}>
                  <Menu.Item key="zh" style={{width: 145, textAlign: "center"}}>中文</Menu.Item>
                  <Menu.Item key="en" style={{width: 145, textAlign: "center"}}>English</Menu.Item>
                </Menu>
              )}>
                <div style={{marginLeft:16}}>
                  <img style={{height:16}} src="/images/index/language.png" alt="" />
                </div>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </div>
      <a id="device"></a>
      <div className="indexPadding"  style={{ width: "100%",marginTop:20, paddingRight: paddingWidth, paddingLeft: paddingWidth ,borderRadius:16}}>
        <div  className="bgBox" style={{backgroundImage:"url(images/index/contact.jpg)",height:360,marginLeft:88,marginRight:88,borderRadius:16}}>
          <div style={{fontSize:i18n.language=="zh"?32:22, textAlign:"right", fontWeight:600,paddingTop:40,marginRight:40}}>
            <span className="deviceContactText1">{t("联系我们")}</span><br/>
            <a className="deviceContactText2" href="mailto:mdm@willingtek.com">mdm@willingtek.com</a>
          </div>
        </div>
      </div>
      <div  style={{ width: "100%",marginTop:40, paddingRight: paddingWidth, paddingLeft: paddingWidth }}>
        <Form
          name="basic"
          form={dataForm}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14 }}
          //style={{ maxWidth: 600 }}
          autoComplete="off"
        >
          <Form.Item
            label={t("咨询类型")}
            name="zxType"
            rules={[{ required: true }]}
          >
            <Select placeholder={t("请选择咨询类型")}>
              <Select.Option value={1}>操作流程</Select.Option>
              <Select.Option value={2}>系统故障</Select.Option>
              <Select.Option value={3}>商务咨询</Select.Option>
              <Select.Option value={4}>其他</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label={t("联系人姓名")}
            name="name"
            rules={[{ required: true }]}
          >
            <Input></Input>
          </Form.Item>
          <Form.Item
            label={t("联系人邮箱")}
            name="email"
            //rules={[{ required: true }]}
          >
            <Input></Input>
          </Form.Item>
          <Form.Item
            label={t("咨询详情")}
            name="content"
            rules={[{ required: true }]}
          >
            <Input.TextArea 
              rows={4} 
              maxLength={150} 
              showCount
            ></Input.TextArea>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6, span: 14 }}>
            <Button type="primary" onClick={() => { onOk(); } } className="login-form-button" htmlType="submit">
              {t("提交")}
            </Button>
          </Form.Item>
        </Form>
      </div>
      <a id="contact"></a>
      <div className="indexPadding" style={{ marginTop:36,backgroundColor: "#242424", width: "100%", height: 215, paddingRight: paddingWidth, paddingLeft: paddingWidth }}>
   
        <Row style={{ marginTop: 16 }}>
          <Col span={6} style={{ textAlign: "center" }}>
            <p><a className="deviceContactText1"> {t("关注我们")}</a></p>
            <img className="deviceContactImage" src="images/willingqrcode.jpg"></img>
          </Col>
          <Col span={8}>
            <p className="deviceContactText2">{t("联系我们")}：</p>
            <p><a className="deviceContactText2" href="mailto:mdm@willingtek.com">mdm@willingtek.com</a></p>
            <p className="deviceContactText2">{t("工作时间")}：</p>
            <p className="deviceContactText2">{t("周一")}~{t("周日")} 9:00-21:00</p>
          </Col>
          <Col span={8}>
            <p className="deviceContactText2">Copyright@2024  {t("深圳未瓴科技有限公司")}</p>
            <p className="deviceContactText2">粤ICP备2024242499号</p>
          </Col>
        </Row>

      </div>
    </Layout>)
  );
}

export default ContactPage;
